import { SystemCamera } from '../System/systemCamera';
import { IShader } from '../Material/Shader/shader';
import {
    DEFAULT_LAYER, ElementLayer, ILayer, ILayerNumber
} from './elementLayer';
import { WHITE_NOISE } from '~src/Material/Shader/shaderSave';
import { ScrollPath } from '~src/Catchers/scrollPath';

export interface IElementBackground {
    layer: ILayer;
    shader: IShader
}

export const DEFAULT_ELEMENT_LAYER: IElementBackground = {
    layer: { ...DEFAULT_LAYER },
    shader: {
        //! Do not import TEXTURE_NOISE from bucketAsset or viewer build is heavy
        // textureNoise: TEXTURE_NOISE[0].url,
        textureNoise: WHITE_NOISE,
        textureFrequency: 0.1,
        alpha: 0,
        chromatic: 0,
        blur: 0,
        // noiseIntensity: 0,
        // noiseSpeed: 0,
        shaderColor1: [0, 0.5, 1],
        shaderColor2: [0, 0.5, 0],
    }
};

export class ElementBackground extends ElementLayer {
    constructor(system: SystemCamera, scrollPath: ScrollPath) {
        super(system, scrollPath);
        this.setShaderValue('isLayer', 1);
        this.setShaderValue('useDEAA', 0);
        this.setBackTextureFrequency(2);
    }

    public name: string;

    public updateName() {
        const layerOp = this.layer;
        this.name = `${layerOp.path} with ${layerOp.shape}`;
    }

    public set options(v: IElementBackground) {
        this.layer = v.layer;
        this.setBackShader(v.shader);
        this.updateName();
    }

    public get options(): IElementBackground {
        return {
            layer: this.layer,
            shader: this.shader
        };
    }

    public setBackShader(shader = this.shader) {
        this.setAndSaveShader(shader);
        this.setTextureUrl(shader.textureNoise);
        this.setWireframe(shader.wireframe);
        this.setBackTextureFrequency(shader.textureFrequency);
    }

    public set layer(v: ILayer) {
        this._layer = v;
        this.updateLayer();
        this.setBackTextureFrequency();
    }

    public get layer(): ILayer {
        return { ...this._layer };
    }

    public setLayerNumbers(layer: ILayerNumber) {
        const keys = Object.keys(layer);
        keys.forEach((key) => {
            this._layer[key] = layer[key];
        });
        this.updateLayerPath();
        this.setBackTextureFrequency();
    }

    private planeTextureRatio = 20;

    private setBackTextureFrequency(textureFrequency = this.shader.textureFrequency) {
        this.shader.textureFrequency = textureFrequency;
        if (this.layer.shape === 'Ribbon') {
            this.setTextureFrequency(textureFrequency * this.planeTextureRatio);
        } else {
            this.setTextureFrequency(textureFrequency);
        }
    }

    private setTextureUrl(textureNoise = this.shader.textureNoise) {
        this.setTextureSamplerUrl(textureNoise, () => {
            // Otherwise we don't see the change in editor
            this.system.scene.render();
        });
    }

    public setWireframe(wireframe: boolean) {
        this.shader.wireframe = wireframe;
        this.shaderMaterial.wireframe = wireframe;
    }
}
